export const SITE_URL = "https://gztengsheng.cn";

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "讨论版", to: "/topics" },
  { label: "板块导航", to: "/#boards" },
  { label: "关于我们", to: "/about" },
];

export const boardThemes: Record<
  string,
  { chip: string; dot: string; soft: string }
> = {
  primary: {
    chip: "bg-primary-100 text-primary-800",
    dot: "bg-primary-500",
    soft: "bg-primary-50",
  },
  accent: {
    chip: "bg-accent-100 text-accent-800",
    dot: "bg-accent-500",
    soft: "bg-accent-50",
  },
  secondary: {
    chip: "bg-secondary-100 text-secondary-800",
    dot: "bg-secondary-500",
    soft: "bg-secondary-50",
  },
};